import { Grid } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';

import { InspirationCard } from '$/pages/DashboardPages/pages/Inspiration/components/InspirationCard/InspirationCard';
import { LoadingInspirationCard } from '$/pages/DashboardPages/pages/Inspiration/components/InspirationCard/LoadingInspirationCard';
import { useInspirationStore } from '$/pages/DashboardPages/pages/Inspiration/stores/useInspirationStore';
import { createPopularityRank } from '$/pages/DashboardPages/pages/Inspiration/utils/popularityUtils';
import { type Inspiration } from '$/services/usecases/inspirations/mapper/inspiration.schema';
import { allInspirationsQuery } from '$/services/usecases/inspirations/queries';
import { materialTemplateColumn } from '$/theme/utils/templateColumn';
import { repeat } from '$/utils/arrayUtils';

export const InspirationOverview = () => {
  const { data, isLoading } = useQuery(allInspirationsQuery());

  const activeCategory = useInspirationStore.useActiveCategory();

  const getShuffledScenes = (scenes: Inspiration[]) => {
    const sortedScenes = scenes.filter((item) =>
      activeCategory ? item.category === activeCategory : true,
    );

    return sortedScenes.map(createPopularityRank(sortedScenes));
  };

  return (
    <Grid
      gap={{ base: '3', md: '6' }}
      autoFlow='dense'
      templateColumns={materialTemplateColumn()}
    >
      {isLoading &&
        repeat(50).map((id) => <LoadingInspirationCard key={id} id={id} />)}

      {data &&
        getShuffledScenes(data.response.payload).map((inspiration) => (
          <InspirationCard key={inspiration.id} inspiration={inspiration} />
        ))}
    </Grid>
  );
};
